<ng-container *ngIf="loading$ | async">
    <app-is-loading></app-is-loading>
</ng-container>

<body>
    <div>
        <h3 *ngIf="systemParameters[0] != null && systemParameters[0] != undefined">{{systemParameters[0].parameterValue1}}</h3>
	    <span class="pageHeader">Contact Us</span>
        <ng-container *ngIf="hasParameterValue(12)">
            <p>{{systemParameters[12].parameterValue1}}</p>
        </ng-container>
        <ng-container *ngIf="!hasParameterValue(12)">
            <p>Please contact 
                <ng-container *ngIf="systemParameters[4] != null && systemParameters[4] != undefined && systemParameters[4].parameterValue1 != '' && systemParameters[4].parameterValue1 != null">
                    the {{systemParameters[4].parameterValue1}} at
                </ng-container>
                <ng-container *ngIf="(systemParameters[4] == null || systemParameters[4] == undefined || systemParameters[4].parameterValue1 == '' && systemParameters[4].parameterValue1 != null) && systemParameters[3] != null && systemParameters[3] != undefined && systemParameters[3].parameterValue1 != '' && systemParameters[3].parameterValue1 != null">
                    the {{systemParameters[3].parameterValue1}} at
                </ng-container>
                the Administrative Office with any questions about the 
                Web Employer Reporting Form (WebERF).
            </p>
        </ng-container>
    </div>
    
    <div>
        <ng-container *ngIf="hasParameterValue(0) || hasParameterValue(1) || hasParameterValue(2)">
            <strong>Mailing Address:</strong><br />
            {{systemParameters[0].parameterValue1}} <br/>
            {{systemParameters[1].parameterValue1}} <br/>
            {{systemParameters[2].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(7)">
            <strong>Phone:</strong>&nbsp; 
            {{systemParameters[7].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(8)">
            <strong>Phone 2:</strong>&nbsp; 
            {{systemParameters[8].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(9)">
            <strong>Toll free:</strong>&nbsp; 
            {{systemParameters[9].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(6)">
            <strong>Fax:</strong>&nbsp; 
            {{systemParameters[6].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(5)">
            <strong>Email:</strong>&nbsp; 
            {{systemParameters[5].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(3)">
            <strong>Attn:</strong>&nbsp; 
            {{systemParameters[3].parameterValue1}} <br/>
        </ng-container>
        <ng-container *ngIf="hasParameterValue(11)">
            <strong>Plan Administrator:</strong>&nbsp; 
            {{systemParameters[11].parameterValue1}} <br/>
        </ng-container>
    </div>
    <ng-container *ngIf="hasParameterValue(10)">
        <p>{{systemParameters[10].parameterValue1}}</p>
    </ng-container>

    <ng-container *ngIf="!this.authService.isUserSignedin()">
        <a href="/login" style="text-decoration: underline;">Back to Login</a>
    </ng-container>
</body>